import { render, staticRenderFns } from "./EventAppointments.vue?vue&type=template&id=2819981a&scoped=true&"
import script from "./EventAppointments.vue?vue&type=script&lang=ts&"
export * from "./EventAppointments.vue?vue&type=script&lang=ts&"
import style0 from "./EventAppointments.vue?vue&type=style&index=0&id=2819981a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2819981a",
  null
  
)

export default component.exports